"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var docDefinitions;
        (function (docDefinitions) {
            var index;
            (function (index) {
                class InitArgs {
                    constructor() {
                        this.docDefinitionsIndex = appn.emptyString;
                        this.docDefinitionsCreate = appn.emptyString;
                    }
                }
                let _initArgs;
                let _dataTable = null;
                function init(args) {
                    _initArgs = args;
                    appn.folderFilter.init(_initArgs.docDefinitionsIndex);
                    createDataTable();
                }
                index.init = init;
                function createDataTable() {
                    _dataTable = appn.dataTable.create('.dataTable', {
                        sAjaxSource: 'DocDefinitions/DataTable',
                        fnServerData: function (data) {
                            data.push(appn.dataTable.getStateOrDefault('sCustom_0', $('#sCustom_0').prop('checked')), { name: 'sCustom_1', value: appn.folderFilter.getStateOrDefault().value });
                        },
                        autoWidth: false,
                        aaSorting: [[1, 'asc']],
                        aoColumns: [
                            { bSortable: false, sWidth: '3%' },
                            { bSortable: true, sWidth: '60%' },
                            { bSortable: true, sWidth: '17%' },
                            { bSortable: true, sWidth: '17%' }
                        ],
                        fnInitComplete: function () {
                            appn.actionButtons.renderNavbarActionButtons([
                                { buttonId: 'organiseBtn', buttonType: 'Organise', isDataTableToggleBtn: true },
                                { buttonId: 'manageBtn', buttonType: 'Manage', isDataTableToggleBtn: true }
                            ], appn.requestUser.isUserOrHigher, true);
                            appn.actionButtons.renderNavbarActionButtons([
                                { buttonId: 'addnew', buttonType: 'AddNew' }
                            ], appn.requestUser.isUserOrHigher);
                            $('#addnew').click(function (event) {
                                event.preventDefault();
                                appn.location.navTo(_initArgs.docDefinitionsCreate, [
                                    {
                                        name: 'folderId',
                                        value: appn.folderFilter.selectedFolderId
                                    }
                                ]);
                            });
                            appn.sideFilterAndContent.appendShowButton($('#DataTables_Table_0_filter'));
                            $('#organiseBtn').click(function () {
                                appn.folderFilter.showDialog($(this), appn.strings.organiseDocs);
                            });
                            $('#manageBtn').click(function (event) {
                                event.preventDefault();
                                if ($(this).css('opacity') === '1') {
                                    const selectedItems = $('.selectRow:checked');
                                    let docKeys = '';
                                    $(selectedItems).map(function () {
                                        docKeys += ($(this).attr('id')) + ',';
                                    });
                                    $('#docsToManage').val(docKeys);
                                    $('#manageDocsDialog').modal('show');
                                    const submitButton = $('#manageDocsDialog .card-header button[value="Manage_Trash"].btn-tool-danger');
                                    appn.trash.createTrashMessageFromTable(submitButton, selectedItems, T('Docs'));
                                }
                            });
                            $('.dataTables_filter').prepend(appn.elementBuilder.buildCheckbox(appn.strings.showArchived, 'saveMeState', 'sCustom_0'));
                            appn.dataTable.addSearchPlaceholder(T('Filter results where the Docs <b>Name, External Id or Status</b> contains a keyword typed in here.'));
                            appn.saveMeState.init(function () {
                                _dataTable.fnDraw(false);
                            }, function () {
                                _dataTable.fnDraw(false);
                            }, '.dataTables_filter');
                        }
                    });
                }
            })(index = docDefinitions.index || (docDefinitions.index = {}));
        })(docDefinitions = views.docDefinitions || (views.docDefinitions = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
